import React from "react";
import ModalPopup from "../../../components/newcomponents/ModalPopup";
import close from "../../notes/images/Union (2).svg";
import { store } from "../../../redux/store";
import { toggleNorthwellError } from "../../../redux/actions/globals.action";
import { isNewApp } from "../../../helper/CommonFuncs";
function CustomNorthwellError() {
   return (
      <div className="flex-center">
         <ModalPopup id="media-view-modal-nw">
            <div className="nw-main-container relative pop-in-v2">
               <img
                  className={`close-nw-custom `}
                  onClick={() => {
                     store.dispatch(toggleNorthwellError());
                  }}
                  src={close}
                  alt="close"
               />
               <div className="title-nw-class">{"No Account Found"}</div>
               <div className="content-nw-class">
                  {`Your email address is not associated with a Playback Health ${isNewApp ? "Pro" : ""} account.`}
               </div>
               <button
                  onClick={() => {
                     window.open("https://northwell.service-now.com/mytech", "_blank", "noopener,noreferrer");
                  }}
                  className="button-nw-custom"
               >
                  {"Request Access via MyTech"}
               </button>
            </div>
         </ModalPopup>
      </div>
   );
}

export default CustomNorthwellError;
